import React from "react";
import styles from "./blog-loader.module.scss";
import Image from "next/image";
import blessLoader from "@public/animated-logo-cropped.gif";

type Props = {};

const BlogLoader = (props: Props) => {
  return (
    <div className={styles.loader}>
      <div>
        <Image src={blessLoader} alt="loading-icon" className={styles.loaderIcon} />
      </div>
    </div>
  );
};

export default BlogLoader;
